import { css, cx } from '@linaria/core'
import { type FC, memo } from 'react'
import { Icon } from '#components/Icon'
import type { GroupDataEntry } from '#pages/Configuration/Comparison/useLinearizeComparisonData'
import { fragments, style } from '#styles/index'
import type { ChangeTableContext } from '../useChangesTable'

const rowClass = css`
  display: grid;
  grid-column: 1/13;
  height: 41px;

  &._selectable {
    cursor: pointer;
  }
  

  ._left {
    grid-column: 1/6;
    display: grid;
    grid-template-columns: subgrid;
    background-color:${style.theme.backgroundSurfaceTertiary};
  }
  
  
  ._right {
    flex: 1;
    grid-column: 6/13;
    padding: 19px 20px 0 20px;
    color: ${style.theme.textAccent};
    ${fragments.textStyle.heading.xxs.regular}
    background-color: ${style.theme.backgroundSurfacePrimary};
    display: flex;
    align-items: center;
    gap: 12px;
  }
`

export const ChangeGroupRow: FC<{ entry: GroupDataEntry; context: ChangeTableContext }> = memo(function ComparisonGroupRow({ entry }) {
  const displayElement = entry.base ?? entry.comparison

  if (!displayElement) {
    return null
  }

  return (
    <div className={cx('_row', rowClass)}>
      <div className="_left" />
      <div className="_right">
        <Icon iconUrl={displayElement.iconUrl} />
        {displayElement.title}
      </div>
    </div>
  )
})
